import { createFileRoute } from '@tanstack/react-router'
import { VisitorDetailsRelatedVisitorsPage } from 'features/visitorDetails'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/related-visitors'
)({
  component: VisitorDetailsRelatedVisitorsPage,
})
